import {
  axiosPatchRequest,
  axiosPostRequest,
  getHealthPictureRoute,
} from '../api';
import { CreateMoodDto, GetMoodsDto } from './dtos';
import { Mood, Moods } from './model';

export const getMoodsCall = (moodsDto: GetMoodsDto, clientAction?: string) => {
  return axiosPostRequest<GetMoodsDto, Moods>(
    `${getHealthPictureRoute()}/wellness`,
    moodsDto,
    undefined,
    clientAction
  );
};

export const createMoodCall = (moodDto: CreateMoodDto, clientAction?: string) => {
  return axiosPatchRequest<CreateMoodDto, Mood[]>(
    `${getHealthPictureRoute()}/wellness`,
    moodDto,
    undefined,
    clientAction
  );
};
